import React, { useState, useEffect } from "react";
import axios from "axios";

const CourseTypeManagement = () => {
  const [formData, setFormData] = useState({
    CourseTypeId: "",
    CourseTypeName: "",
  });

  const [courseTypes, setCourseTypes] = useState([]);
  const [isedit, setIsedit] = useState(false);
  const [editingCourseTypeId, setEditingCourseTypeId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    fetchCourseTypes();
  }, []);

  const fetchCourseTypes = async () => {
    try {
      const response = await axios.get("/api/coursetypes");
      setCourseTypes(response.data || []);
    } catch (error) {
      console.error("Error fetching course types:", error);
    }
  };

  const generateCourseTypeId = () => {
    const maxId = courseTypes.reduce((max, ct) => {
      const num = parseInt(ct.CourseTypeId.replace("CT", ""), 10);
      return isNaN(num) ? max : Math.max(max, num);
    }, 100); // Start from 100, so first will be CT101

    const newId = `CT${maxId + 1}`;
    setFormData((prev) => ({
      ...prev,
      CourseTypeId: newId,
    }));
  };

  const handleEdit = (courseType) => {
    setFormData({
      CourseTypeId: courseType.CourseTypeId,
      CourseTypeName: courseType.CourseTypeName,
    });
    setIsedit(true);
    setEditingCourseTypeId(courseType._id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this course type?")) return;
    try {
      await axios.delete(`/api/coursetype/${id}`);
      fetchCourseTypes();
      alert("Course Type deleted successfully!");
    } catch (error) {
      console.error("Error deleting course type:", error);
      alert("Failed to delete course type.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!isedit) {
        const newFormData = { ...formData };
        await axios.post("/api/coursetype", newFormData);
        alert("Course Type added successfully!");
      } else {
        await axios.put(`/api/coursetype/${editingCourseTypeId}`, formData);
        alert("Course Type updated successfully!");
      }
      setFormData({ CourseTypeId: "", CourseTypeName: "" });
      setIsedit(false);
      setEditingCourseTypeId(null);
      fetchCourseTypes();
    } catch (error) {
      console.error("Error submitting course type:", error);
      alert("Failed to submit course type.");
    }
  };

  const handleCancel = () => {
    setFormData({ CourseTypeId: "", CourseTypeName: "" });
    setIsedit(false);
    setEditingCourseTypeId(null);
  };

  const filteredCourseTypes = courseTypes.filter((ct) =>
    ct.CourseTypeName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="container mt-5">
      <h3>Course Type Management</h3>

      <form onSubmit={handleSubmit} className="mb-4">
        <div className="mb-3">
          <label>Course Type ID</label>
          <input
            type="text"
            className="form-control"
            value={formData.CourseTypeId}
            readOnly
            onClick={generateCourseTypeId}
            placeholder="Click to generate ID"
            required
          />
        </div>
        <div className="mb-3">
          <label>Course Type Name</label>
          <input
            type="text"
            className="form-control"
            value={formData.CourseTypeName}
            onChange={(e) => setFormData({ ...formData, CourseTypeName: e.target.value })}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary me-2">
          {isedit ? "Update" : "Submit"}
        </button>
        {isedit && (
          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
        )}
      </form>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search course types..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Course Type ID</th>
            <th>Course Type Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredCourseTypes.map((courseType) => (
            <tr key={courseType._id}>
              <td>{courseType.CourseTypeId}</td>
              <td>{courseType.CourseTypeName}</td>
              <td>
                <button className="btn btn-sm btn-info me-2" onClick={() => handleEdit(courseType)}>
                  Edit
                </button>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(courseType._id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {filteredCourseTypes.length === 0 && (
            <tr>
              <td colSpan="3" className="text-center">
                No course types found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CourseTypeManagement;
